import { useState, useEffect } from 'react';
import { repairInvoicesService, RepairInvoice } from '../services/repairInvoicesService';

export const useRepairInvoices = () => {
  const [invoices, setInvoices] = useState<RepairInvoice[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchRepairInvoices = async () => {
    try {
      setLoading(true);
      setError(null);
      const { invoices: data, error: fetchError } = await repairInvoicesService.getRepairInvoices();

      if (fetchError) {
        throw fetchError;
      }

      setInvoices(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch repair invoices');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepairInvoices();
  }, []);

  const refreshRepairInvoices = () => {
    fetchRepairInvoices();
  };

  return {
    invoices,
    loading,
    error,
    refreshRepairInvoices,
  };
};

export const useRepairInvoice = (id: string | null) => {
  const [invoice, setInvoice] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    const fetchInvoice = async () => {
      try {
        setLoading(true);
        setError(null);
        const { invoice: data, error: fetchError } = await repairInvoicesService.getRepairInvoiceById(id);

        if (fetchError) {
          throw fetchError;
        }

        setInvoice(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch repair invoice');
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id]);

  return {
    invoice,
    loading,
    error,
  };
};